import { style, media } from 'typestyle'
import { important } from 'csx'
export const hidesmi = style(media({ maxWidth: 576 }, { display: important('none') }))
